module.exports = __webpack_public_path__ + "media/images/landkit/avatars/avatar-2-fa6512f0f988597489c61e1dde759648.jpg";